<div class="card mb-4">
    <div class="card-header">
        <h6 class="card-title mb-0" *ngIf="grupoEconomico?.id">GRUPO ECONÔMICO: {{grupoEconomico.nome}}</h6>
        <h6 class="card-title mb-0" *ngIf="!grupoEconomico?.id">NENHUM GRUPO ECONÔMICO</h6>
        <small class="card-subtitle mb-0" *ngIf="subTitle">{{subTitle}}</small>
    </div>

    <div class="table-responsive">
        <table class="table table-bordered table-striped table-hover">
            <thead>
                <tr>
                    <th class="col-select"></th>
                    <th class="col-codigo-integracao">Código</th>
                    <th class="col-cnpj-cpf">CNPJ/CPF</th>
                    <th class="col-nome">Nome</th>
                    <th class="col-nome-fantasia">Nome Fantasia</th>
                    <th class="col-representante">Representante</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let entity of grupoEconomico?.clientes; let i = index">
                    <td class="col-select text-center">
                        <input type="checkbox" [(ngModel)]="entity.selected" (ngModelChange)="select()" name="clienteGrupoEconomicoSelect_{{i}}" id="clienteGrupoEconomicoSelect_{{i}}">
                    </td>
                    <td class="col-codigo-integracao">{{entity.codigoIntegracaoErp}}</td>
                    <td class="col-cnpj-cpf">{{entity.cnpjCpf}}</td>
                    <td class="col-nome">{{entity.nome}}</td>
                    <td class="col-nome-fantasia">{{entity.nomeFantasia}}</td>
                    <td class="col-representante">{{entity.nomeRepresentante | representanteNome: entity.nomeFantasiaRepresentante}}</td>
                </tr>
                <tr *ngIf="!grupoEconomico?.clientes || grupoEconomico?.clientes.length === 0">
                    <td class="text-center" colspan="6">
                        <i class="fas fa-info" aria-hidden="true"></i> Nenhum cliente encontrado
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>